import { render } from "./EventItem.vue?vue&type=template&id=324736bc&scoped=true"
import script from "./EventItem.vue?vue&type=script&lang=js"
export * from "./EventItem.vue?vue&type=script&lang=js"

import "./EventItem.vue?vue&type=style&index=0&id=324736bc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324736bc"]])

export default __exports__